import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { UserChannel, UserSearch } from '../models/user';
import { OtpCheckDTO } from '../models/otp';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  checkId(userId: string){
    return this.http.get<any>(this.commonService.apiUrl + '/users/' + userId + '/exists')
  }
  getRecommendUserNo(userId: string){
    return this.http.get<any>(this.commonService.apiUrl + '/users/recommend/' + userId)
  }

  addUser(formData: FormData) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/signUp', formData);
  }
  updateCorpCodeForAdmin(userNo: number, formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/corpInfo/admin/' + userNo, formData);
  }
  updateCorpCode(formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/corpInfo', formData);
  }
  updateRegidentNumberForAdmin(userNo: number, formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/regidentNumber/admin/' + userNo, formData);
  }
  updateRegidentNumber(formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/regidentNumber', formData);
  }
  updatePasswordForAdmin(userNo: number, updatePassword: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/password/admin/' + userNo, {
      updatePassword: updatePassword
    });
  }
  updatePasswordForBuddy(currentPassword: string, updatePassword: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/updatePassword', {
        currentPassword: currentPassword
      , updatePassword: updatePassword
    });
  }
  findUserId(name: string, tel: string, otpCode: string) {
    //return this.http.get<any>(this.commonService.apiUrl + '/users/' + name + '/' + tel + '/findUserId?otpCode=' + otpCode, {});
    return this.http.post<any>(this.commonService.apiUrl + '/users/findUserId', {
        userName: name
      , tel: tel
      , otpCode: otpCode
    });
  }
  findOasisIdByTel(tel: string, code: string){
    let param: OtpCheckDTO = new OtpCheckDTO()
    param.type = 'SIGN_UP'
    param.tel = tel
    param.code = code
    return this.http.post<any>(this.commonService.apiUrl + '/users/oasisId', param)
  }
  updatePassword(userId: string, otpCode: string, password: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/' + userId + '/updatePassword', {
        otpCode: otpCode
      , password: password
    });
  }
  updateTel(tel: string, otpCode: string) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/tel/update', {
        otpCode: otpCode
      , tel: tel
    });
  }
  updateTelForAdmin(userNo: number, tel: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/tel/admin/' + userNo, {
      tel: tel
    });
  }
  updateUserPaymentInfoForAdmin(userNo: number, formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/paymentInfo/admin/' + userNo, formData);
  }
  updateUserPaymentInfo(formData: FormData) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/paymentInfo/v2', formData);
  }
  addChannel(formData: FormData) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/channel', formData);
  }
  addScreenshot(userChannelNo: number, formData: FormData) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/channel/' + userChannelNo + '/image', formData);
  }
  removeScreenshot(userChannelNo: number) {
    return this.http.delete<any>(this.commonService.apiUrl + '/users/channel/' + userChannelNo + '/image', {});
  }
  removeChannel(userChannelNo: number) {
    return this.http.delete<any>(this.commonService.apiUrl + '/users/channel/' + userChannelNo, {});
  }

  getUserList(search: UserSearch){
    let param = JSON.parse(JSON.stringify(search))
    if(param.keyword == '') param.keyword = null
    if(param.status == '') param.status = null
    if(param.userClass == '') param.userClass = null
    if(param.userGrade == '') param.userGrade = null
    if(param.fromDate != null) param.fromDate = search.fromDate.format('YYYY-MM-DD')
    if(param.toDate != null) param.toDate = search.toDate.format('YYYY-MM-DD')
    return this.http.post<any>(this.commonService.apiUrl + '/users/list', param)
  }
  getUserInfo(userNo: number){
    return this.http.get<any>(this.commonService.apiUrl + '/users/' + userNo, {})
  }

  userConfirm(userNo: number, userGrade: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/confirm', {
        userNo: userNo
      , userGrade: userGrade
    });
  }
  userReject(userNo: number, comment: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/reject', {
      comment: comment
    });
  }
  
  userConfirmRequest(userNo: number, comment: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/confirm/request', {
        userNo: userNo
      , comment: comment
    });
  }
  userGradeUpdate(userNo: number, userGrade: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/grade', {
        userNo: userNo
      , userGrade: userGrade
    });
  }
  userClassUpdate(userNo: number, userClass: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/userClass', {
        userNo: userNo
      , userClass: userClass
    });
  }
  userCommissionPercentUpdate(userNo: number, commissionPercent: number) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/grade', {
      userNo: userNo
      , commissionPercent: commissionPercent
    });
  }
  addUserMemo(userNo: number, memo: string) {
    return this.http.put<any>(this.commonService.apiUrl + '/users/' + userNo + '/memo', {
        memo: memo
    });
  }
  removeUserMemo(memoNo: number) {
    return this.http.delete<any>(this.commonService.apiUrl + '/users/memo/' + memoNo, {});
  }
  getUserMemoList(userNo: number) {
    return this.http.post<any>(this.commonService.apiUrl + '/users/' + userNo + '/memo', {});
  }
}
